import {
  GET_REMINDERS_REQUEST,
  GET_REMINDERS_SUCCESS,
  GET_REMINDERS_FAIL,
} from '../actions/types';

const initialState = {
  loading: false,
  reminders: [], // यहाँ लिस्ट स्टोर होगी
  error: null,
};

export const reminderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REMINDERS_REQUEST:
      return { 
        ...state, 
        loading: true, 
        error: null 
      };
    case GET_REMINDERS_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        reminders: action.payload, // API से आया हुआ पूरा डेटा (Array)
        error: null 
      };
    case GET_REMINDERS_FAIL:
      return { 
        ...state, 
        loading: false, 
        reminders: [],
        error: action.payload 
      };
    default:
      return state;
  }
};

export default reminderReducer;